import { render, staticRenderFns } from "./Norm.vue?vue&type=template&id=aaf9e3f8&scoped=true&"
import script from "./Norm.vue?vue&type=script&lang=js&"
export * from "./Norm.vue?vue&type=script&lang=js&"
import style0 from "./Norm.vue?vue&type=style&index=0&id=aaf9e3f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf9e3f8",
  null
  
)

export default component.exports